import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
var Modal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, onSubmit = _a.onSubmit, children = _a.children;
    var _b = useState(null), portalElement = _b[0], setPortalElement = _b[1];
    useEffect(function () {
        var widgetPortal = document.getElementById('widget-portal-root');
        setPortalElement(widgetPortal || document.body);
    }, []);
    useEffect(function () {
        var handleEnter = function (e) {
            if (e.key === 'Escape')
                onClose === null || onClose === void 0 ? void 0 : onClose();
            if (e.key === 'Enter')
                onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
        };
        if (isOpen) {
            document.addEventListener('keydown', handleEnter);
        }
        return function () {
            document.removeEventListener('keydown', handleEnter);
        };
    }, [isOpen, onClose, onSubmit]);
    if (!isOpen || !portalElement)
        return null;
    return createPortal(React.createElement("div", { className: "fixed inset-0 z-50 flex items-center justify-center" },
        React.createElement("div", { className: "absolute inset-0 backdrop-blur-sm transition-opacity", style: {
                backgroundColor: 'hsl(0deg 0.78% 7.07% / 64%)'
            }, onClick: onClose ? onClose : function () { } }),
        React.createElement("div", { className: "relative bg-white rounded-lg shadow-2xl overflow-hidden transform transition-all animate-in fade-in zoom-in duration-200", style: {
                padding: '1.5rem',
                maxWidth: '36rem'
            } },
            React.createElement("div", null, children))), portalElement);
};
export default Modal;
